import { ModelSagres } from "../../model-sagres"

/**
 * Este modelo é utilizado na página onde uma legislação é preenchida e enviada para a API. 
 * Data a natureza como estas prestações foram modeladas em nosso BD, esta entidade difere da entidade que 
 * exibe uma legislação já cadastrada.
 * 
 * @since 20220728
 */
export class EntregaLegislacaoDto extends ModelSagres {
    exercicio: number
    idTipoEntrega: number
}